import React from 'react';
import './LedenUploadHandoffPanel.css';

/**
 * LedenUploadHandoffPanel
 *
 * Shown on the Conviventies page for an invited target whose ledenlijst is still
 * missing. The Excel upload itself lives only on the Leden page, so this panel
 * explains the handoff and deep-links there with the conviventie and target
 * already selected.
 */
const LedenUploadHandoffPanel = ({ isOpen, targetLabel, onOpenLedenlijst, onClose }) => {
  if (!isOpen) return null;

  return (
    <section className="leden-handoff-panel" aria-label="Ledenlijst uploaden">
      <div className="leden-handoff-header">
        <div>
          <h3>Ledenlijst uploaden - {targetLabel}</h3>
          <p>
            Ledenlijsten worden beheerd op de Leden-pagina. Open die pagina om een
            Excel-ledenlijst te uploaden, of om leden handmatig toe te voegen.
          </p>
        </div>
        <button type="button" className="button button-secondary" onClick={onClose}>
          Sluiten
        </button>
      </div>

      <div className="leden-handoff-actions">
        <button type="button" className="button button-primary" onClick={onOpenLedenlijst}>
          Naar de Leden-pagina
        </button>
      </div>
    </section>
  );
};

export default LedenUploadHandoffPanel;